/**
 * @author       carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright    Copyright (c) 2021, Zumper
 */

import {
  type BANNER_TYPE,
  BannerWrapper,
  DISMISS_APP_BANNER,
  hideAppBanner,
  isBannerDismissed,
  selectAppBannerShowing,
  selectBannerAlreadyShown,
  setBannerAlreadyShown,
  showAppBanner,
} from '@zcode-ui/app-download-banner'
import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'
import type { Dispatch } from '../../modules/types'

function setDismissAppBannerCookie() {
  document.cookie = `${DISMISS_APP_BANNER}=true;max-age=${7 * 24 * 3600}`
}

export const mapStateToProps = (state: State) => ({
  show: selectAppBannerShowing(state),
  bannerAlreadyShown: selectBannerAlreadyShown(state),
})

/**
 *
 * @param {import('redux').Dispatch} dispatch
 */
export const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: { type: keyof typeof BANNER_TYPE }
) => ({
  onClose: () => {
    setDismissAppBannerCookie()
    dispatch(hideAppBanner())
  },
  onMount: () => {
    dispatch((_, getState) => {
      const state = getState()
      const bannerAlreadyShown = selectBannerAlreadyShown(state)

      if (bannerAlreadyShown || isBannerDismissed()) {
        dispatch(hideAppBanner())
      } else {
        dispatch(showAppBanner())
      }
    })
  },
  onUnmount: () => {
    if (ownProps.type !== 'GALLERY') {
      // Because we use <StrictMode>, when running locally, this code will be triggered an extra time
      // by react, as soon as the page loads.
      // This causes the banner to be hidden very soon after the page loads, even if the user has never
      // seen the banner before
      dispatch(setBannerAlreadyShown())
      dispatch(hideAppBanner())
    }
  },
})

export const AppBannerContainer = connect(mapStateToProps, mapDispatchToProps)(BannerWrapper)
